import useShipmentFetch from "./useShipmentFetch";

export default () => {
  const { shipmentFetch, isLoading } = useShipmentFetch()

  return {
    fetchImplementations: async ({ accountId }) => {
      const response = await shipmentFetch(`accounts/implementations?accountId=${accountId}`, { method: 'GET' })
      return response || []
    },
    isImplementationsLoading: isLoading
  }
}